import { IEquipment } from '../../../../../equipment.types.ts'
import TextStatisticCard from '@/shared/Analytics/TextStatisticCard'
import useParameterValue from '@/services/data/hooks/useParameterValue.ts'
import cn from '@/utils/cn.ts'

const lkdsWorkModeLabels: Record<number, string> = {
  0: 'Нормальная работа',
  1: 'Погрузка',
  2: 'Пожарная опасность, ППП',
  3: 'Ревизия',
  4: 'Управление из МП',
  5: 'МП1',
  6: 'Ввод параметров',
  7: 'МП2',
  8: 'Корректировочный рейс',
  9: 'Утренний режим',
  10: 'Вечерний режим',
  11: 'С проводником',
  12: 'Дистанционное отключение',
  13: 'Режим авария',
  14: 'Сейсмическая опасность',
  15: 'Больничный режим',
  16: 'Аварийная остановка',
  17: 'Out of Service',
  18: 'Пожарная тревога',
  19: 'Режим ППП',
  20: 'Режим эвакуации',
  21: 'Режим VIP',
  22: 'Независимый режим',
  23: 'Режим парковки',
  24: 'Приоритет вызовов',
  25: 'Приоритет приказов',
  26: 'Останов по STOP',
  27: 'Режим SLEEP',
}

interface IProps {
  equipmentId: IEquipment['id']
  title: string
}

const LkdsModeCard = (props: IProps) => {
  const mode = useParameterValue(props.equipmentId, 'elevatorWorkMode')
  const modeValue = mode.value === null || mode.value === undefined ? null : Number(mode.value)
  const label = mode.loading ? '' : (lkdsWorkModeLabels[modeValue ?? -1] ?? '—')
  const isNormal = modeValue === 0

  return (
    <TextStatisticCard title={props.title} loading={mode.loading} width="100%" height="84px">
      <p
        className={cn({
          'text-heading-5': true,
          'text-success': isNormal,
          'text-warning': modeValue !== null && !isNormal,
        })}
      >
        {label}
      </p>
    </TextStatisticCard>
  )
}

export default LkdsModeCard
